import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, round } from 'lodash';
import uuid from 'uuid/v1';
import * as d3 from 'd3';

const COL_PADDING = 15;
const HANDLE_RADIUS = 7.5;
const HEIGHT = 38;
const MARGIN = 10;
const WIDTH = 250;
// const ISMAPEDITOR = false;

class DoubleRangeSlider extends Component {
  axis = null;

  lineSelectedZoomLevels = null;

  lineTrack = null;

  lineTrackInset = null;

  randomSVGId = uuid();

  x = null;

  xAxis = null;

  state = {
    width: 400
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
    this.initializeSlider();
  }

  componentDidUpdate() {
    this.printSlider();
  }

  initializeSlider = () => {
    const { changeMaxValue, changeMinValue } = this.props;
    const { width } = this.state;

    const svg = d3.select(`#zoom-slider-${this.randomSVGId}`);

    this.x = d3
      .scaleLinear()
      .domain(this.props.domain)
      .range([0, width - 2 * MARGIN]);

    this.xAxis = d3.axisBottom(this.x).ticks();

    const slider = svg
      .append('g')
      .attr('class', 'slider')
      .attr('width', width - 2 * MARGIN)
      .attr('transform', `translate(${MARGIN},${HEIGHT / 2})`);

    this.axis = slider.append('g').attr('class', 'axis');

    const dragLeftHandle = d3
      .drag()
      .on('start.interrupt', slider.interrupt)
      .on('start drag end', () => {
        changeMinValue(round(this.x.invert(d3.event.x)));
      });

    const dragRightHandle = d3
      .drag()
      .on('start.interrupt', slider.interrupt)
      .on('start drag end', () => {
        changeMaxValue(round(this.x.invert(d3.event.x)));
      });

    this.lineTrack = slider
      .append('line')
      .style('stroke', '#000')
      .style('stroke-linecap', 'round')
      .style('stroke-width', '5px');

    this.lineTrackInset = this.lineTrack
      .select(function appendLineChild() {
        return this.parentNode.appendChild(this.cloneNode(true));
      })
      .style('stroke', '#ddd')
      .style('stroke-width', '3px');

    this.lineSelectedZoomLevels = this.lineTrack
      .select(function appendLineChild() {
        return this.parentNode.appendChild(this.cloneNode(true));
      })
      .style('stroke', '#007bff')
      .style('stroke-width', '3px');

    this.lineTrack.style('stroke-opacity', 0.3);

    this.leftHandle = slider
      .append('circle')
      .style('fill', '#007bff')
      .style('stroke', '#000')
      .style('stroke-opacity', 0.3)
      .style('cursor', 'crosshair')
      .attr('cy', 0)
      .attr('r', HANDLE_RADIUS)
      .call(dragLeftHandle);

    this.rightHandle = slider
      .append('circle')
      .style('fill', '#007bff')
      .style('stroke', '#000')
      .style('stroke-opacity', 0.3)
      .style('cursor', 'crosshair')
      .attr('cy', 0)
      .attr('r', HANDLE_RADIUS)
      .call(dragRightHandle);

    this.printSlider();
  };

  printSlider = () => {
    const { maxValue, minValue } = this.props;
    const { width } = this.state;

    this.x.range([0, width - 2 * MARGIN]).clamp(true);

    this.axis.call(this.xAxis).lower();

    this.lineTrack.attr('x1', 0).attr('x2', width - 2 * MARGIN);
    this.lineTrackInset.attr('x1', 0).attr('x2', width - 2 * MARGIN);
    this.lineSelectedZoomLevels.attr('x1', this.x(minValue)).attr('x2', this.x(maxValue));

    this.leftHandle.attr('cx', this.x(minValue));
    this.rightHandle.attr('cx', this.x(maxValue));
  };

  updateDimensions = () => {
    let aspectRatio = 1;
    if (window.innerWidth < 768) aspectRatio = 1;
    else if (window.innerWidth < 992) aspectRatio = 1 / 2;
    else aspectRatio = 1 / 3;
    const windowWidth = get(window, 'visualViewport.width', 0);
    const isMapEditor = true;
    const width = isMapEditor ? WIDTH : windowWidth * aspectRatio - 2 * COL_PADDING;
    this.setState({ width });
  };

  render() {
    const { width } = this.state;
    return <svg id={`zoom-slider-${this.randomSVGId}`} width={width} height={HEIGHT} />; // Eliminada linea isMapEditor={ISMAPEDITOR} desconozco si se trata de algo que se queria implementar a futuro y se quedo descolgado
  }
}

DoubleRangeSlider.propTypes = {
  changeMaxValue: PropTypes.func.isRequired,
  changeMinValue: PropTypes.func.isRequired,
  domain: PropTypes.array.isRequired,
  maxValue: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired
};

export default DoubleRangeSlider;
